<template>
  <div class="team">
    <heads></heads>
    <div class="team-title" v-if="pageArray.length>0">优秀的定制方案</div>
    <div class="container" v-if="pageArray.length>0">
      <div class="content">
        <div
          class="rotation-right"
          v-for="(item,index) in pageArray"
          :key="index"
          @click="toDetail(item.id)"
        >
          <div class="trans-img">
            <img :src="item.linePictureUrl" class="right-img" />
          </div>
          <div class="padd-info">
            <div class="right-infoitem">{{item.lineTitile}}</div>
            <div class="info-describe">{{item.lineAbstract}}</div>
            <div class="right-infobottom">
              <div class="right-price">￥{{item.price}}</div>
              <div>
                <span>{{fomateDate(item.date)}}</span>
                <span class="weeeks" v-if="item.signUpStatus=='已满员'">{{item.signUpStatus}}</span>
                <span class="weeek" v-else>{{item.signUpStatus}}</span>
              </div>
            </div>
          </div>
        </div>

        <template v-if="afterLength">
          <div class="between-after" v-for="(item,index) in afterLength"></div>
        </template>

      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNumber"
          :page-size="10"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <div class="team-title">您的旅行计划</div>
    <div class="team-content">
      <div class="team-item">
        <div class="team-one">
          <span class="team-text">出发时间:</span>
          <el-date-picker v-model="departureTime" type="date" placeholder="选择您的出发日期"></el-date-picker>
        </div>
        <div class="team-one">
          <span class="team-text">意向路线:</span>
          <input
            type="text"
            v-model="destination"
            placeholder="(海边、爬山、景区等类型)"
            class="teaminfo"
            ref="destination"
          />
        </div>
        <div class="team-one">
          <span class="team-text">出发地点:</span>
          <input
            type="text"
            v-model="departurePlace"
            placeholder="(请填写出发地点)"
            class="teaminfo"
            ref="departurePlace"
          />
        </div>
      </div>
      <div class="team-item">
        <div class="team-one">
          <span class="team-text">活动天数:</span>
          <input
            type="text"
            v-model="travelDuration"
            placeholder="请填写活动天数"
            class="teaminfo"
            ref="travelDuration"
          />
        </div>
        <div class="team-one">
          <span class="team-text">活动人数:</span>
          <input
            type="text"
            v-model="adultsNumber"
            placeholder="请填写活动人数"
            class="teaminfo"
            ref="adultsNumber"
          />
        </div>
        <div class="team-one">
          <span class="team-text">人均预算:</span>
          <input
            type="text"
            v-model="perCapitaBudget"
            placeholder="请填写人均预算"
            class="teaminfo"
            ref="perCapitaBudget"
          />
        </div>
      </div>
      <div class="team-item">
        <div class="team-one">
          <span class="team-text">活动性质:</span>
          <input
            type="text"
            v-model="activityKind"
            placeholder="(纯玩、拓展或其他)"
            class="teaminfo"
            ref="activityKind"
          />
        </div>
        <div class="team-one">
          <span class="team-text">以往出行经历:</span>
          <input
            type="text"
            v-model="travelExperience"
            placeholder="请填写以前的出行经历"
            class="teaminfo"
            ref="travelExperience"
          />
        </div>
      </div>
    </div>
    <div class="team-title">您的联系方式</div>
    <div class="team-content">
      <div class="team-item">
        <div class="team-one">
          <span class="team-text">您的称呼:</span>
          <input
            type="text"
            v-model="contactName"
            placeholder="方便客服与您的联系"
            class="teaminfo"
            ref="contactName"
          />
        </div>
        <!-- <div class="team-one">
          <span class="team-text">E-mail:</span>
          <input type="text" v-model="email" placeholder="请填写您的电子邮箱" class="teaminfo" ref="email" />
        </div>-->
        <div class="team-one">
          <span class="team-text">手机号码:</span>
          <input
            type="text"
            v-model="contactNumber"
            placeholder="方便客服与您的联系"
            class="teaminfo"
            ref="contactNumber"
          />
        </div>
        <div class="team-one">
          <span class="team-text">性别:</span>
          <div class="info">
            <span @click="gender=1" class="select" :class="[gender==1? 'select-active' : '']">先生</span>
            <span @click="gender=0" class="select" :class="[gender==0 ? 'select-active' : '']">女士</span>
          </div>
        </div>
      </div>
      <div class="team-item">
        <div class="team-two">
          <span class="team-text">联系时间:</span>
          <div class="info">
            <span
              class="btn"
              @click="contactTime=0"
              :class="[contactTime==0 ? 'btn-active' : '']"
            >9:00~12:00</span>
            <span
              class="btn"
              @click="contactTime=1"
              :class="[contactTime==1 ? 'btn-active' : '']"
            >14:00~18:00</span>
            <span
              class="btn"
              @click="contactTime=2"
              :class="[contactTime==2? 'btn-active' : '']"
            >19:00~22:00</span>
          </div>
        </div>
      </div>
      <div class="team-item">
        <div class="team-three">
          <span class="team-text">其他要求:</span>
          <textarea
            class="teaminfos"
            :rows="3"
            type="text"
            v-model="otherRequirements"
            placeholder="请填写您的其他需求"
          />
        </div>
      </div>
    </div>
    <div class="tobtn">
      <div class="team-btn" @click="toTeam()">提交定制</div>
    </div>
    <homeFoots></homeFoots>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import { fomateDate } from "@/util/util.js";
import axios from "axios";
import qs from "qs";
export default {
  name: "team",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      navArray: ["周边多天", "周边一天", "国内线路", "国外线路"],
      searchVal: "",
      styleId: "",
      pageArray: [],
      loading: false,
      id: "",

      destination: "",
      departurePlace: "",
      departureTime: this.fomateDate(new Date()),
      travelDuration: "",
      adultsNumber: "",
      childrenNumber: "",
      contactName: "",
      gender: 1,
      contactNumber: "",
      email: "",
      contactTime: 0,
      otherRequirements: "",
      perCapitaBudget: "",
      travelExperience: "",
      activityKind: "",
    };
  },
  components: {
    heads,
    homeFoots,
    banners,
  },
  computed: {
    afterLength() {
      //填充元素的长度
      const num = this.pageArray.length % 5;
      switch (num) {
        case 2:
        case 3:
        case 4:
          return 4 - num;
          break;
        default:
          return 0;
          break;
      }
    },
  },
  methods: {
    fomateDate,
    toTeam() {
      if (!this.departurePlace) {
        this.$message({
          message: "请填写出发地点",
          center: true,
          duration: 1500,
        });
        this.$nextTick(function () {
          this.$refs.departurePlace.focus();
        });
        return;
      }
      if (!this.travelDuration) {
        this.$message({
          message: "请填写您的活动天数",
          center: true,
          duration: 1500,
        });
        this.$nextTick(function () {
          this.$refs.travelDuration.focus();
        });
        return;
      }
      if (!this.adultsNumber) {
        this.$message({
          message: "请填写您的活动人数",
          center: true,
          duration: 1500,
        });
        this.$nextTick(function () {
          this.$refs.adultsNumber.focus();
        });
        return;
      }
      if (!this.perCapitaBudget) {
        this.$message({
          message: "请填写您的人均预算",
          center: true,
          duration: 1500,
        });
        this.$nextTick(function () {
          this.$refs.perCapitaBudget.focus();
        });
        return;
      }

      if (!this.contactName) {
        this.$message({
          message: "请填写您的姓名",
          center: true,
          duration: 1500,
        });
        this.$nextTick(function () {
          this.$refs.contactName.focus();
        });
        return;
      }
      var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.contactNumber) || !this.contactNumber) {
        this.$message({
          message: "请填写有效的手机号码~",
          type: "success",
          duration: 2000,
          center: true,
        });
        this.$nextTick(function () {
          this.$refs.contactNumber.focus();
        });
        return;
      }

      let params = {
        destination: this.destination,
        departurePlace: this.departurePlace,
        departureTime: this.fomateDate(this.departureTime),
        travelDuration: this.travelDuration,
        adultsNumber: this.adultsNumber,
        contactName: this.contactName,
        gender: this.gender,
        contactNumber: this.contactNumber,
        contactTime: this.contactTime,
        otherRequirements: this.otherRequirements,
        perCapitaBudget: this.perCapitaBudget,
        activityKind: this.activityKind,
        travelExperience: this.travelExperience,
      };
      axios
        .post(
          `/mobile/ly_line_customization/lineCustomization.jhtml`,
          qs.stringify(params)
        )
        .then((res) => {
          if (res.data.success) {
            this.$message("提交成功");
            setTimeout(() => {
              this.$router.push({ path: `/` });
            }, 800);
          } else {
            this.$message("系统繁忙，请稍后再试~");
          }
        })
        .catch((res) => {
          this.$message("系统繁忙，请稍后再试~");
        });
    },
    handleCurrentChange(val) {
      this.getActivity();
    },
    handleSizeChange(val) {},
    toDetail(id) {
      this.$router.push({
        path: "/activityDetail",
        // query: { id: this.searchVal }
        query: { id: id },
      });
    },
    tosearch() {
      this.loading = true;
      this.getActivity();
    },
    getActivity() {
      const params = {
        pageNumber: this.pageNumber,
        pageSize: 10,
        lineIconId: this.id,
      };

      axios
        .get(`/mobile/line/lineList.jhtml`, {
          params,
        })
        .then((res) => {
          if (res.data.success) {
            this.pageArray = res.data.returnValue.lineList;
            this.total = res.data.returnValue.total;
          }
          //   this.loading = false;
        });
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }

    // this.loading = true;
    this.getActivity();
  },
  created() {},
};
</script>

<style scoped>
.team {
  width: 100%;
  height: 100%;
  /* text-align: left; */
}
.team-title {
  font-size: 22px;
  line-height: 40px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
}
.team-content {
  /* width: 100%; */
  width: 84%;
  margin: 10px auto;
  /* border-top: 4px solid #cccccc; */
}
.tobtn {
  width: 84%;
  margin: 80px auto;
}
.team-btn {
  cursor: pointer;
  border-radius: 6px;
  width: 140px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #007741;
  color: #fff;
  margin: 0 auto;
}
.team-item {
  width: 100%;
  /* justify-content: space-between; */
  display: flex;
  /* margin-right: 40px; */
  /* align-items: center; */
}

.team-one {
  width: 30%;
  display: flex;
  height: 60px;
  align-items: center;
  margin-right: 40px;
}
.team-three {
  width: 100%;
  display: flex;
  height: 60px;
  align-items: top;
  margin-right: 40px;
  margin-top: 16px;
}
.team-item > .team-one:nth-child(3) {
  margin-right: 0;
}
.team-two {
  width: 50%;
  display: flex;
  height: 60px;
  align-items: center;
}
.team-text {
  width: 120px;
  text-align: right;
  display: block;
  font-size: 16px;
  font-weight: bold;
  margin-right: 10px;
}
.info {
  display: flex;
  /* font-size: 16px; */
  text-align: left;
  /* padding-left: 30px; */
  box-sizing: border-box;
  flex: 1;
}
.select {
  cursor: pointer;
  position: relative;
  /* margin-left: 16px; */
  margin-right: 16px;
  padding: 10px 16px;
  border: 1px solid #cccccc;
  /* border-radius: 5px; */
}
.select-active {
  background: #007741;
  border: 1px solid #007741;
  color: #fff;
}
.btn {
  display: inline-block;
  margin-right: 10px;
  padding: 6px 10px;
  border: 1px solid #007741;
  /* border-radius: 5px; */
  color: #007741;
  font-size: 14px;
  cursor: pointer;
}

.btn-active {
  background: #007741;
  color: #ffffff;
}
.teaminfo {
  border: 1px solid #cccccc;
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
}
.teaminfos {
  border: 1px solid #cccccc;
  padding: 10px;
  border-radius: 6px;
  width: 300px;
  font-size: 14px;
}
.container {
  text-align: left;
  margin-bottom: 20px;
  /* margin-top: 20px; */
}
.search-wrapper {
  width: 100%;
  /* position: absolute; */
  display: flex;
  justify-content: center;
  bottom: 0px;
  z-index: 9;
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
  padding: 20px 0;

  /* background: rgba(0, 0, 0, 0.38); */
}
.search-input-wrapper {
  display: flex;
  border-radius: 4px;
  padding: 5px;
  margin-top: 8px;
  position: relative;
  width: 800px;
}
.search-input {
  flex: 1;
  padding: 0 10px;
  /* border: 0; */
  border-radius: 4px;
  line-height: 45px;
  border: 1px solid #cccccc;
}
.search-btn {
  background: #007741;
  padding: 12px 25px;
  border-radius: 0 4px 4px 0;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}
.search-btn:hover {
  background: #05a35c;
}
.search-radio {
  position: absolute;
  right: 120px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.title {
  display: inline-block;
  margin: 20px 0;
  padding: 0 8px;
  color: #007741;
  border-bottom: 2px solid #007741;
  font-weight: bold;
  height: 30px;
  font-size: 16px;
  text-align: center;

  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.textnav {
  display: flex;
  width: 100%;
  justify-content: space-around;
  height: 40px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  margin-top: 30px;
  padding: 0 240px;
  box-sizing: border-box;
}
.textnav > span {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}
.nac-active {
  color: #007741;
  font-weight: bold;
  border-bottom: 2px solid #007741;
}
.content {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  /* min-height: 200px; */
  justify-content: space-between;
}
.rotation-left {
  position: relative;
  width: 65%;
  height: 420px;
  margin-bottom: 20px;
}

.label {
  padding: 6px 12px;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.8);
  line-height: 40px;
}
.label-text {
  height: 40px;
  line-height: 40px;
  border-top: 1px solid #ffffff;
}
.info-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}
.right-infobottom {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  font-size: 12px;
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  box-sizing: border-box;
}
.weeek {
  display: inline-block;
  margin-left: 8px;
  background: #007640;
  color: #fff;
  font-size: 12px;
  padding: 4px 6px;
  border-radius: 12px;
  cursor: pointer;
}
.weeeks {
  display: inline-block;
  margin-left: 8px;
  background: #b87f06;
  color: #fff;
  font-size: 12px;
  padding: 4px 6px;
  border-radius: 12px;
  cursor: pointer;
}
.rotation-right {
  position: relative;
  width: 18%;
  height: 300px;
  background: #faf7f7;
  padding-bottom: 41px;
  box-sizing: border-box;
  cursor: pointer;
  margin-bottom: 10px;
  /* margin-right: 20px; */
}
.between-after {
  position: relative;
  width: 18%;
  height: 300px;
  padding-bottom: 41px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.between-after {
  position: relative;
  width: 22%;
  height: 340px;
  padding-bottom: 41px;
  box-sizing: border-box;
  margin-bottom: 10px;
  /* margin-right: 20px; */
}
.rotation-right:hover .right-img {
  transform: scale(1.2);
}
.rotation-right:hover {
  box-shadow: 0px 0px 10px #aaaaaa;
}
.padd-info {
  padding: 0 6px;
  box-sizing: border-box;
}
.trans-img {
  width: 100%;
  height: 60%;
  overflow: hidden;
}
.right-img {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
/* .right-img:hover {
  transform: scale(1.2);
} */
/* .right-img {
  width: 100%;
  height: 60%;
} */
.right-infoitem,
.info-describe {
  font-size: 13px;
  margin: 0 12px;
}
.right-infoitem {
  font-size: 15px;
  font-weight: bold;
  line-height: 22px;
  height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-top: 8px;
}
.info-describe {
  color: #676767;
  line-height: 22px;
  font-size: 12px;
  margin-top: 6px;
  height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.right-price {
  font-size: 14px;
  font-weight: bold;
  color: #e40808;
}
</style>



// WEBPACK FOOTER //
// src/components/activityview/team.vue